import React, { FC, useState } from 'react';
import featurePosts, { formatFeatureDate, tagColors, FeaturePost } from './FeaturePosts';
import { features } from 'texts/texts';
import { TextWithStyle } from 'components/TextWithStyle';
import { SEO } from 'components/seo/SEO';
import { breadcrumbJsonLd, itemListJsonLd } from 'components/seo/organizationSchema';
import routeManifest from 'routes/routeManifest.json';
import { PostCard, PostCardGrid, TagFilter } from 'components/postCard/PostCard';

// Page layout (header, container) shared with the blog
import '../blog/Blog.css';
import './Features.css';

const route = routeManifest.find((r) => r.path === '/features')!;
const breadcrumbs = breadcrumbJsonLd([
  { name: 'Home', path: '/' },
  { name: 'Features', path: '/features' },
]);
const featureList = itemListJsonLd(
  featurePosts.map((post) => ({ name: post.title, path: `/features/${post.id}` }))
);

export const Features: FC = () => {
  const [selectedTag, setSelectedTag] = useState<string>('View All');

  return (
    <div className="blog-section">
      <SEO
        title={route.title}
        description={route.description}
        path={route.path}
        jsonLd={featurePosts.length ? [breadcrumbs, featureList] : [breadcrumbs]}
      />
      <div className="blog-content-container">
        <div className="blog-header">
          <h1>
            {features.title.map((part, index) => (
              <TextWithStyle key={index} text={part.text} style={part.style} />
            ))}
          </h1>
          <p>{features.description}</p>
          <TagFilter tagColors={tagColors} selected={selectedTag} onSelect={setSelectedTag} />
        </div>

        {featurePosts.length === 0 && <p className="features-empty">Feature pages coming soon 🌱</p>}

        <PostCardGrid>
          {featurePosts
            .filter((post: FeaturePost) => selectedTag === 'View All' || post.tag === selectedTag)
            .map((post: FeaturePost) => (
              <PostCard
                key={post.id}
                to={`/features/${post.id}`}
                image={post.cardImage ?? post.image}
                imageCover={post.screenshot}
                tag={post.tag}
                color={tagColors[post.tag]}
                title={post.title}
                subtitle={post.subtitle}
                readTime={post.readTime}
                date={formatFeatureDate(post.date)}
                dateTime={post.date}
              />
            ))}
        </PostCardGrid>
      </div>
    </div>
  );
};
